import ISO8601 from '@square/dashboard-data/models/squareup/bills/iso8601-date';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';

// This implements the squareup.bills.DatePair proto

export default ProtoBaseModel.extend({
  clientDate: attr(ISO8601),
  serverDate: attr(ISO8601)
});